<template>
  <div class="demos-page">
    <nav-bar />

    <section class="demos-content">
      <div class="container">
        <transition
          name="panel-fade"
          mode="out-in"
        >
          <div
            :key="profile"
            class="panel"
          >

            <!-- ── Étudiant ── -->
            <div
              v-if="profile === 'etudiant'"
              class="side-layout"
            >
              <div class="side-text">
                <span class="demo-badge badge-blue">{{ $t('demosPage.student.badge') }}</span>
                <h2>{{ $t('demosPage.student.title') }}</h2>
                <p>{{ $t('demosPage.student.desc') }}</p>
                <ul class="side-features">
                  <li>
                    <span class="feat-icon feat-blue"><svg
                      viewBox="0 0 24 24"
                      fill="none"
                    ><circle
                      cx="12"
                      cy="10"
                      r="7"
                      fill="#e0f3ff"
                      stroke="#00A3FF"
                      stroke-width="1.6"
                    /><circle
                      cx="9"
                      cy="10"
                      r="1.2"
                      fill="#00A3FF"
                    /><circle
                      cx="12"
                      cy="10"
                      r="1.2"
                      fill="#00A3FF"
                    /><circle
                      cx="15"
                      cy="10"
                      r="1.2"
                      fill="#00A3FF"
                    /><path
                      d="M12 17v3M9 20h6"
                      stroke="#00A3FF"
                      stroke-width="1.8"
                      stroke-linecap="round"
                    /></svg></span>
                    <div><strong>{{ $t('demosPage.student.features.chatbot.title') }}</strong><p>{{ $t('demosPage.student.features.chatbot.desc') }}</p></div>
                  </li>
                  <li>
                    <span class="feat-icon feat-yellow"><svg
                      viewBox="0 0 24 24"
                      fill="none"
                    ><circle
                      cx="12"
                      cy="12"
                      r="9"
                      fill="#fff7e0"
                      stroke="#FFC400"
                      stroke-width="1.6"
                    /><text
                      x="12"
                      y="17"
                      text-anchor="middle"
                      font-size="13"
                      font-weight="900"
                      fill="#FFC400"
                      font-family="Inter,sans-serif"
                    >?</text></svg></span>
                    <div><strong>{{ $t('demosPage.student.features.quizzes.title') }}</strong><p>{{ $t('demosPage.student.features.quizzes.desc') }}</p></div>
                  </li>
                  <li>
                    <span class="feat-icon feat-red"><svg
                      viewBox="0 0 24 24"
                      fill="none"
                    ><rect
                      x="5"
                      y="7"
                      width="13"
                      height="10"
                      rx="2.5"
                      fill="#ffe8e8"
                      stroke="#f97066"
                      stroke-width="1.5"
                    /><rect
                      x="7"
                      y="5"
                      width="13"
                      height="10"
                      rx="2.5"
                      fill="#fff0f0"
                      stroke="#f97066"
                      stroke-width="1.5"
                    /><path
                      d="M10 11h5M12 9v4"
                      stroke="#f97066"
                      stroke-width="1.8"
                      stroke-linecap="round"
                    /></svg></span>
                    <div><strong>{{ $t('demosPage.student.features.flashcards.title') }}</strong><p>{{ $t('demosPage.student.features.flashcards.desc') }}</p></div>
                  </li>
                  <li>
                    <span class="feat-icon feat-green"><svg
                      viewBox="0 0 24 24"
                      fill="none"
                    ><rect
                      x="4"
                      y="3"
                      width="16"
                      height="18"
                      rx="3"
                      fill="#e8f7e8"
                      stroke="#22c55e"
                      stroke-width="1.5"
                    /><path
                      d="M8 8h8M8 12h6M8 16h4"
                      stroke="#22c55e"
                      stroke-width="1.8"
                      stroke-linecap="round"
                    /></svg></span>
                    <div><strong>{{ $t('demosPage.student.features.notes.title') }}</strong><p>{{ $t('demosPage.student.features.notes.desc') }}</p></div>
                  </li>
                </ul>
                <a
                  v-if="registrationEnabled"
                  href="/register/student"
                  class="demo-cta cta-blue"
                >
                  {{ $t('demosPage.cta.createAccount') }}
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></svg>
                </a>
                <a
                  v-else
                  href="/contact"
                  class="demo-cta cta-blue"
                  @click.prevent="$router.push('/contact')"
                >
                  {{ $t('demosPage.cta.contact') }}
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></svg>
                </a>
              </div>
              <div class="side-demo">
                <div class="iframe-wrap">
                  <iframe
                    src="/index3.html"
                    frameborder="0"
                    scrolling="no"
                    loading="lazy"
                    :title="$t('demosPage.iframes.student')"
                  />
                </div>
              </div>
            </div>

            <!-- ── Enseignant ── -->
            <div
              v-else-if="profile === 'enseignant'"
              class="side-layout"
            >
              <div class="side-text">
                <span class="demo-badge badge-purple">{{ $t('demosPage.teacher.badge') }}</span>
                <h2>{{ $t('demosPage.teacher.title') }}</h2>
                <p>{{ $t('demosPage.teacher.desc') }}</p>
                <ul class="side-features">
                  <li>
                    <span class="feat-icon feat-red"><svg
                      viewBox="0 0 24 24"
                      fill="none"
                    ><path
                      d="M12 3L3 7v5c0 5.25 3.75 10.15 9 11.35C17.25 22.15 21 17.25 21 12V7L12 3z"
                      fill="#ffe8e8"
                      stroke="#f97066"
                      stroke-width="1.5"
                      stroke-linejoin="round"
                    /><path
                      d="M9 12l2 2 4-4"
                      stroke="#f97066"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    /></svg></span>
                    <div><strong>{{ $t('demosPage.teacher.features.antiCheat.title') }}</strong><p>{{ $t('demosPage.teacher.features.antiCheat.desc') }}</p></div>
                  </li>
                  <li>
                    <span class="feat-icon feat-blue"><svg
                      viewBox="0 0 24 24"
                      fill="none"
                    ><rect
                      x="4"
                      y="4"
                      width="16"
                      height="16"
                      rx="3"
                      fill="#e0f3ff"
                      stroke="#00A3FF"
                      stroke-width="1.5"
                    /><path
                      d="M8 9h8M8 12h5M8 15h6"
                      stroke="#00A3FF"
                      stroke-width="1.8"
                      stroke-linecap="round"
                    /></svg></span>
                    <div><strong>{{ $t('demosPage.teacher.features.fromMaterials.title') }}</strong><p>{{ $t('demosPage.teacher.features.fromMaterials.desc') }}</p></div>
                  </li>
                  <li>
                    <span class="feat-icon feat-green"><svg
                      viewBox="0 0 24 24"
                      fill="none"
                    ><circle
                      cx="12"
                      cy="12"
                      r="9"
                      fill="#e8f7e8"
                      stroke="#22c55e"
                      stroke-width="1.5"
                    /><path
                      d="M8 12l3 3 5-5"
                      stroke="#22c55e"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    /></svg></span>
                    <div><strong>{{ $t('demosPage.teacher.features.grading.title') }}</strong><p>{{ $t('demosPage.teacher.features.grading.desc') }}</p></div>
                  </li>
                  <li>
                    <span class="feat-icon feat-yellow"><svg
                      viewBox="0 0 24 24"
                      fill="none"
                    ><rect
                      x="3"
                      y="3"
                      width="18"
                      height="18"
                      rx="3"
                      fill="#fff7e0"
                      stroke="#FFC400"
                      stroke-width="1.5"
                    /><path
                      d="M7 17l3-4 3 3 2-3 3 4"
                      stroke="#FFC400"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    /></svg></span>
                    <div><strong>{{ $t('demosPage.teacher.features.classDashboard.title') }}</strong><p>{{ $t('demosPage.teacher.features.classDashboard.desc') }}</p></div>
                  </li>
                </ul>
                <a
                  v-if="registrationEnabled"
                  href="/register/tutor"
                  class="demo-cta cta-purple"
                >
                  {{ $t('demosPage.cta.createAccount') }}
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></svg>
                </a>
                <a
                  v-else
                  href="/contact"
                  class="demo-cta cta-purple"
                  @click.prevent="$router.push('/contact')"
                >
                  {{ $t('demosPage.cta.contact') }}
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></svg>
                </a>
              </div>
              <div class="side-demo">
                <div class="iframe-wrap">
                  <iframe
                    src="/index2.html"
                    frameborder="0"
                    scrolling="no"
                    loading="lazy"
                    :title="$t('demosPage.iframes.teacher')"
                  />
                </div>
              </div>
            </div>

            <!-- ── Établissement ── -->
            <div
              v-else
              class="school-stacked"
            >

              <!-- Bloc 1 : Automatisation / Scan & Extraction -->
              <div class="school-block">
                <div class="school-block-header">
                  <span class="demo-badge badge-teal">{{ $t('demosPage.school.block1.badge') }}</span>
                  <h2>{{ $t('demosPage.school.block1.title') }}</h2>
                  <p>{{ $t('demosPage.school.block1.desc') }}</p>
                </div>
                <div class="iframe-wrap">
                  <iframe
                    src="/index5.html"
                    frameborder="0"
                    scrolling="no"
                    loading="lazy"
                    :title="$t('demosPage.iframes.schoolScan')"
                  />
                </div>
                <div class="feat-grid feat-grid-row">
                  <div class="feat-card">
                    <span class="feat-icon feat-teal"><svg
                      viewBox="0 0 24 24"
                      fill="none"
                    ><rect
                      x="4"
                      y="3"
                      width="16"
                      height="18"
                      rx="3"
                      fill="#eaf2ff"
                      stroke="#0B5FFF"
                      stroke-width="1.5"
                    /><path
                      d="M8 7h8M8 11h8M8 15h5"
                      stroke="#0B5FFF"
                      stroke-width="1.8"
                      stroke-linecap="round"
                    /><circle
                      cx="18"
                      cy="17"
                      r="4"
                      fill="#0B5FFF"
                    /><path
                      d="M16.5 17l1 1 2-2"
                      stroke="#fff"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    /></svg></span>
                    <strong>{{ $t('demosPage.school.block1.features.scan.title') }}</strong>
                    <p>{{ $t('demosPage.school.block1.features.scan.desc') }}</p>
                  </div>
                  <div class="feat-card">
                    <span class="feat-icon feat-yellow"><svg
                      viewBox="0 0 24 24"
                      fill="none"
                    ><path
                      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
                      fill="#fff7e0"
                      stroke="#FFC400"
                      stroke-width="1.5"
                      stroke-linejoin="round"
                    /><path
                      d="M14 2v6h6M12 18v-4M10 16h4"
                      stroke="#FFC400"
                      stroke-width="1.8"
                      stroke-linecap="round"
                    /></svg></span>
                    <strong>{{ $t('demosPage.school.block1.features.contracts.title') }}</strong>
                    <p>{{ $t('demosPage.school.block1.features.contracts.desc') }}</p>
                  </div>
                </div>
              </div>

              <!-- Séparateur -->
              <div class="school-divider" />

              <!-- Bloc 2 : CRM Admissions -->
              <div class="school-block">
                <div class="school-block-header">
                  <span class="demo-badge badge-blue">{{ $t('demosPage.school.block2.badge') }}</span>
                  <h2>{{ $t('demosPage.school.block2.title') }}</h2>
                  <p>{{ $t('demosPage.school.block2.desc') }}</p>
                </div>
                <div class="iframe-wrap">
                  <iframe
                    src="/index6.html"
                    frameborder="0"
                    scrolling="no"
                    loading="lazy"
                    :title="$t('demosPage.iframes.schoolCrm')"
                  />
                </div>
                <div class="feat-grid feat-grid-row">
                  <div class="feat-card">
                    <span class="feat-icon feat-blue"><svg
                      viewBox="0 0 24 24"
                      fill="none"
                    ><path
                      d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                      fill="#e0f3ff"
                      stroke="#00A3FF"
                      stroke-width="1.5"
                      stroke-linejoin="round"
                    /><circle
                      cx="9"
                      cy="7"
                      r="4"
                      fill="#e0f3ff"
                      stroke="#00A3FF"
                      stroke-width="1.5"
                    /><path
                      d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
                      stroke="#00A3FF"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    /></svg></span>
                    <strong>{{ $t('demosPage.school.block2.features.pipeline.title') }}</strong>
                    <p>{{ $t('demosPage.school.block2.features.pipeline.desc') }}</p>
                  </div>
                  <div class="feat-card">
                    <span class="feat-icon feat-green"><svg
                      viewBox="0 0 24 24"
                      fill="none"
                    ><rect
                      x="3"
                      y="3"
                      width="18"
                      height="18"
                      rx="3"
                      fill="#e8f7e8"
                      stroke="#22c55e"
                      stroke-width="1.5"
                    /><path
                      d="M7 17l3-4 3 3 2-3 3 4"
                      stroke="#22c55e"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    /></svg></span>
                    <strong>{{ $t('demosPage.school.block2.features.overview.title') }}</strong>
                    <p>{{ $t('demosPage.school.block2.features.overview.desc') }}</p>
                  </div>
                </div>
              </div>

              <!-- CTA commun -->
              <div class="school-cta-wrap">
                <a
                  href="/contact"
                  class="demo-cta cta-teal"
                >
                  {{ $t('demosPage.cta.requestDemo') }}
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></svg>
                </a>
              </div>

            </div>

          </div>
        </transition>
      </div>
    </section>

    <page-footer />
  </div>
</template>

<script>
import navBar from '@/views/home/HomePage2/components/navBar.vue'
import pageFooter from '@/views/home/HomePage2/components/pageFooter.vue'

export default {
  name: 'DemosPage',
  components: {
    navBar,
    pageFooter,
  },
  data() {
    return {
      profile: this.normalizeProfile(this.$route.query.profil) || 'etudiant',
      schoolTab: 'scan',
    }
  },
  computed: {
    registrationEnabled() {
      return process.env.VUE_APP_REGISTRATION_ENABLED === 'true'
    },
  },
  watch: {
    '$route.query.profil': function (val) {
      const next = this.normalizeProfile(val)
      this.profile = next || 'etudiant'
      if (this.profile !== 'ecole') this.schoolTab = 'scan'
    },
    profile: 'updateTitle',
    '$i18n.locale': 'updateTitle',
  },
  mounted() {
    this.updateTitle()
  },
  beforeDestroy() {
    document.title = "TUT'TOP"
  },
  methods: {
    updateTitle() {
      const titleKeyByProfile = {
        etudiant: 'demosPage.titles.student',
        enseignant: 'demosPage.titles.teacher',
        ecole: 'demosPage.titles.school',
      }
      const key = titleKeyByProfile[this.profile]
      document.title = key ? this.$t(key) : "TUT'TOP"
    },
    normalizeProfile(val) {
      const v = String(val || '').toLowerCase().trim()
      if (['etudiant', 'student'].includes(v)) return 'etudiant'
      if (['enseignant', 'teacher', 'prof'].includes(v)) return 'enseignant'
      if (['ecole', 'école', 'school'].includes(v)) return 'ecole'
      return null
    },
  },
}
</script>

<style scoped>
.demos-page {
  background: linear-gradient(180deg, #ffffff 0%, var(--bg-sky) 42%, #ffffff 100%);
  min-height: 100vh;
}

.container {
  max-width: 1140px;
  margin: 0 auto;
  padding: 0 24px;
}

.demos-content {
  padding: 110px 0 110px;
  background: transparent;
}

.panel {
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 22px;
  padding: 34px;
  background: #fff;
  box-shadow: 0 20px 60px rgba(0,0,0,0.10);
  display: flex;
  flex-direction: column;
  gap: 28px;
  position: relative;
  overflow: hidden;
}

.panel::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--brand-blue), var(--brand-blue-deep));
  opacity: 0.95;
}

.school-tabs {
  display: inline-flex;
  gap: 8px;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 999px;
  padding: 6px;
  margin-bottom: 16px;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}

.tab-btn {
  border: none;
  background: transparent;
  border-radius: 999px;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 800;
  color: var(--muted);
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
  white-space: nowrap;
}

.tab-btn:hover {
  background: rgba(0, 163, 255, 0.08);
  color: #0f172a;
}

.tab-btn.active {
  background: linear-gradient(135deg, var(--brand-blue), var(--brand-blue-deep));
  color: #fff;
  box-shadow: 0 10px 24px rgba(0, 163, 255, 0.24);
}

.iframe-wrap {
  width: 100%;
  height: 580px;
  border-radius: 16px;
  overflow: hidden;
  background: var(--bg-sky);
  border: 1px solid rgba(15, 23, 42, 0.08);
}

.iframe-wrap iframe {
  width: 100%;
  height: 100%;
  border: none;
  overflow: hidden;
}

/* ── Student / Teacher side-by-side layout ── */
.side-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: center;
}

.side-text {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.side-text h2 {
  margin: 0;
  font-size: clamp(20px, 2.6vw, 28px);
  font-weight: 800;
  color: #0f172a;
  line-height: 1.25;
}

.side-text > p {
  margin: 0;
  font-size: 15px;
  color: var(--muted);
  line-height: 1.65;
}

.side-features {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.side-features li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.side-features li div { display: flex; flex-direction: column; gap: 2px; }
.side-features li strong { font-size: 13.5px; font-weight: 700; color: #0f172a; }
.side-features li p { margin: 0; font-size: 12.5px; color: var(--muted); line-height: 1.5; }

.side-demo .iframe-wrap {
  box-shadow: 0 24px 70px rgba(0,0,0,.09);
  border-radius: 20px;
  border: 1px solid rgba(15,23,42,.07);
}

/* ── School stacked layout ── */
.school-stacked {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.school-block {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.school-block-header {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.school-block-header h2 {
  margin: 0;
  font-size: clamp(20px, 2.4vw, 26px);
  font-weight: 800;
  color: #0f172a;
  line-height: 1.25;
}

.school-block-header p {
  margin: 0;
  font-size: 15px;
  color: var(--muted);
  line-height: 1.65;
  max-width: 680px;
}

.school-divider {
  height: 1px;
  background: rgba(15, 23, 42, 0.08);
  margin: 36px 0;
}

.school-cta-wrap {
  display: flex;
  justify-content: center;
  padding-top: 12px;
}

.feat-grid-row {
  grid-template-columns: 1fr 1fr;
}

/* badges */
.demo-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .07em;
  text-transform: uppercase;
  border-radius: 999px;
  padding: 5px 14px;
  width: fit-content;
}
.badge-blue   { color: #0b1220; background: rgba(255, 196, 0, 0.22); border: 1px solid rgba(255, 196, 0, 0.32); }
.badge-purple { color: var(--brand-blue); background: rgba(0, 163, 255, 0.10); border: 1px solid rgba(0, 163, 255, 0.22); }
.badge-teal   { color: var(--brand-blue-deep); background: rgba(11, 95, 255, 0.10); border: 1px solid rgba(11, 95, 255, 0.22); }

/* CTA buttons */
.demo-cta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 22px;
  color: #0b1220;
  font-size: 14px;
  font-weight: 700;
  border-radius: 999px;
  text-decoration: none;
  width: fit-content;
  transition: filter .2s ease, transform .2s ease;
  background: var(--brand-gold);
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 12px 28px rgba(255, 196, 0, 0.22);
}
.demo-cta:hover { filter: brightness(1.08); transform: translateY(-2px); }
.demo-cta svg { width: 16px; height: 16px; }
.cta-blue, .cta-purple, .cta-teal { background: var(--brand-gold); box-shadow: 0 12px 28px rgba(255, 196, 0, 0.22); }

/* feature cards grid */
.feat-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.feat-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  background: #fff;
  border: 1px solid rgba(15,23,42,.07);
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0,0,0,.05);
}

.feat-card strong { font-size: 13px; font-weight: 700; color: #0f172a; }
.feat-card p { margin: 0; font-size: 12.5px; color: var(--muted); line-height: 1.5; }

/* icons */
.feat-icon {
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  border-radius: 11px;
  display: grid;
  place-items: center;
  border: 1px solid transparent;
}
.feat-icon svg { width: 22px; height: 22px; }

.feat-blue   { background: #e0f3ff; border-color: rgba(0, 163, 255, 0.22); }
.feat-yellow { background: #fff7e0; border-color: rgba(255, 196, 0, 0.30); }
.feat-red    { background: #ffe8e8; border-color: rgba(249,112,102,.2); }
.feat-green  { background: #e8f7e8; border-color: rgba(34,197,94,.2); }
.feat-teal   { background: #eaf2ff; border-color: rgba(11, 95, 255, 0.22); }

.panel-fade-enter-active,
.panel-fade-leave-active {
  transition: opacity 0.22s ease, transform 0.22s ease;
}
.panel-fade-enter,
.panel-fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

@media (max-width: 900px) {
  .side-layout { grid-template-columns: 1fr; gap: 28px; }
  .side-text h2 { font-size: 20px; }
}

@media (max-width: 768px) {
  .demos-content { padding: 90px 0 80px; }
  .panel { padding: 20px; gap: 20px; }
  .iframe-wrap { height: 380px; }
  .feat-grid { grid-template-columns: 1fr 1fr; }
  .feat-grid-row { grid-template-columns: 1fr; }
  .school-divider { margin: 24px 0; }
}
</style>
